import storage from "good-storage";
import Cookies from "js-cookie";
import { extend, isEmpty } from "./commonUtil";
/**
 * 本地存储工具
 *
 */
export var scopeNameMap;
(function (scopeNameMap) {
  scopeNameMap["session"] = "session";
  scopeNameMap["cookie"] = "cookie";
})(scopeNameMap || (scopeNameMap = {}));
const config = {
  prefix: "aiwen_"
};
/**
 *
 * 获取符合本地存储规则的key,类内部调用的方法，禁止外部调用
 * @param {*} key
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _getKey(key, option) {
  if (option && option.notPrefix) {
    return key;
  }
  if (option && !isEmpty(option.prefix)) {
    key = option.prefix + key;
  } else {
    key = config.prefix + key;
  }
  return key;
}
/**
 *
 *
 * @param {*} key
 * @param {*} val
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _set(key, val, option) {
  key = _getKey(key, option);
  const scope = getScope(option);
  if (scope) {
    scope.set(key, val);
  }
}
/**
 *
 *
 * @param {*} key
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _get(key, option) {
  key = _getKey(key, option);
  const scope = getScope(option);
  if (scope) {
    return scope.get(key);
  }
  // return getScope(option)?.get(key);
}
/**
 *
 *
 * @param {*} key
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _remove(key, option) {
  key = _getKey(key, option);
  const scope = getScope(option);
  if (scope) {
    return scope.remove(key);
  }
  // getScope(option)?.remove(key);
}
/**
 *
 *
 * @param {*} key
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _hasStorage(key, option) {
  key = _getKey(key, option);
  const storage = getScope(option);
  if (storage) {
    return storage.has(key);
  }
  return false;
}
/**
 *
 *
 * @param {*} callBack
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _forEachStorage(callBack, option) {
  const storage = getScope(option);
  if (storage) {
    return storage.has(callBack);
  }
}
/**
 *
 *
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _clearStorage(option) {
  const storage = getScope(option);
  if (storage) {
    return storage.clear();
  }
}
/**
 *
 *
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
function _getAllStorage(option) {
  const storage = getScope(option);
  if (storage) {
    return storage.getAll();
  }
  return [];
}
/**
 *
 *
 * @param {*} scopeName
 * @param {*} option
 * @return {*}
 * @memberof LocalStorageUtil
 */
export function getScope(option) {
  if (!option || isEmpty(option.scopeName)) {
    return storage;
  } else {
    const scopeName = option.scopeName;
    if (scopeName == scopeNameMap.cookie) {
      return Cookies;
    } else if (scopeName && storage[scopeName]) {
      return storage[scopeName];
    } else {
      console.error("scopeName ", scopeName, " is not defined!");
    }
  }
}
export function forEachStorage(callback, option) {
  return _forEachStorage(callback, option);
}
/**
 *
 * 将key：val存储到本地存储系统中，默认添加到localStorage中
 * @param {string} key
 * @param {*} val
 * @param {Option} [option]
 * @return {*}  {LocalStorageUtil}
 * @memberof LocalStorageUtil
 */
export function set(key, val, option) {
  return _set(key, val, option);
}
export function get(key, option) {
  return _get(key, option);
}
export function remove(key, option) {
  return _remove(key, option);
}
export function hasStorage(key, option) {
  return _hasStorage(key, option);
}
export function clearStorage(option) {
  return _clearStorage(option);
}
export function getAllStorage(option) {
  return _getAllStorage(option);
}
/**
 *
 * 将key：val存储到sessionStorage中
 * @param {string} key
 * @param {*} val
 * @return {*}  {LocalStorageUtil}
 * @memberof LocalStorageUtil
 */
export function setSession(key, val, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.session
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.session
    });
  }
  return _set(key, val, option);
}
/**
 *
 * 从sessionStorage 获取某个key所对应得值
 * @param {string} key
 * @param {*} [def] //当没有数据时，返回默认值
 * @return {*}  {*}
 * @memberof LocalStorageUtil
 */
export function getSession(key, def, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.session,
      default: def
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.session,
      default: def
    });
  }
  return _get(key, option);
}
/**
 *
 * 判断session中是否含有某个key
 * @param {string} key
 * @return {*}  {boolean}
 * @memberof LocalStorageUtil
 */
export function hasSession(key, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.session
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.session
    });
  }
  return _hasStorage(key, option);
}
/**
 *
 * 从sessionStorage 中移除某个key
 * @param {string} key
 * @return {*}  {LocalStorageUtil}
 * @memberof LocalStorageUtil
 */
export function removeSession(key, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.session
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.session
    });
  }
  return _remove(key, option);
}
/**
 *
 * 清除sessionStorage 中的所有数据
 * @return {*}  {LocalStorageUtil}
 * @memberof LocalStorageUtil
 */
export function clearSession() {
  return _clearStorage({
    scopeName: scopeNameMap.session
  });
}
export function setCookie(key, value, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.cookie
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.cookie
    });
  }
  _set(key, value, option);
}
export function getCookie(key, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.cookie
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.cookie
    });
  }
  return _get(key, option);
}
export function removeCookie(key, option) {
  if (!option) {
    option = {
      scopeName: scopeNameMap.cookie
    };
  } else {
    extend(option, {
      scopeName: scopeNameMap.cookie
    });
  }
  return _remove(key, option);
}